import React, { useState } from "react";
import { useTranslations } from "../../hooks/useTranslations";

interface props {
    email: string,
    onSubmit: (email: string) => void
};

const EmailInput = (props: props) => {
    const { t } = useTranslations();
    
    const [email, setEmail] = useState<string>(props.email);

    const clickNext = () => {
        props.onSubmit(email);
    };


    return (<>
        <div className="card-body text-start">
            <h5 className="card-title">{t('welcome.emailaddress')}</h5>

            <div className="input-group mb-3">
                <span className="input-group-text" id="labelEmail">@</span>
                <input type="email"
                    className="form-control"
                    placeholder="username@domain.tld"
                    aria-label="e-Mai"
                    aria-describedby="labelEmail"
                    value={email}
                    onChange={(evt) => setEmail(evt.target.value)}
                />
            </div>

            <p className="card-text">{t('welcome.enteremailaddress')}</p>
        </div>
        <div className="card-footer text-muted text-end">
            <button className="btn btn-outline-primary" onClick={clickNext}>{t('common.next')}</button>
        </div>
    </>);
}

export { EmailInput };
